import script from "./PrintFormSuratPernyataanDukungan.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintFormSuratPernyataanDukungan.vue?vue&type=script&setup=true&lang=js"

import "./PrintFormSuratPernyataanDukungan.vue?vue&type=style&index=0&id=6c97a42b&lang=css"

const __exports__ = script;

export default __exports__